/**
 * 同じ親のもとに並んでいる兄弟のうち、
 * 「この id の前」か「この id の後」に新しい id を差し込む。
 */
export type SiblingInsertPosition = 'top' | 'bottom'

/**
 * 兄弟 node id の並びに、新しい node id を1つ挿入した **新しい配列** を返す。
 *
 * ## ひな形編集でのイメージ
 *
 * ページやセクションは、子どもの node id を **順序付きリスト** (`nodes: number[]`) で持つ。
 * 「質問A の下に表を追加」のような操作は、実際にはこの配列の **どこに新 id を入れるか** を決める処理になる。
 *
 * ```text
 * ページ.nodes = [質問1, セクションA, 質問2]
 *                      ↑ ここに表(id=99)を bottom で差し込む
 * 結果           = [質問1, セクションA, 99, 質問2]
 * ```
 *
 * precondition:
 * - siblingIds はソート済み
 * - anchorNodeId は siblingIds に含まれる
 */
export const insertSiblingNodeId = (
  siblingIds: number[],
  anchorNodeId: number,
  newNodeId: number,
  position: SiblingInsertPosition,
): number[] => {
  if (siblingIds.length === 0) {
    return [newNodeId]
  }

  const anchorIndex = siblingIds.findIndex(id => id === anchorNodeId)
  const insertIndex = position === 'top' ? anchorIndex : anchorIndex + 1
  const next = [...siblingIds]
  next.splice(insertIndex, 0, newNodeId)
  return next
}
